import { api } from './client';
import { PartnerType, Role } from '@/domain/types';

/** GET /profile — the caller's own account details. */
export interface Profile {
  fullName: string;
  firstName: string;
  lastName: string;
  email: string;
  role: Role;
  /** Denormalised partner type; null for RADIUS_ADMIN. */
  partner: PartnerType | null;
  /** Optional admin-managed detail fields — null unless an admin set them. */
  city: string | null;
  stateProvince: string | null;
  managerName: string | null;
  /** Free-text job title, labelled "Role" in the UI (not `role` above). */
  jobTitle: string | null;
  profile: string | null;
}

export interface ProfileResponse {
  profile: Profile;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export const profileApi = {
  // Get current user profile
  getProfile: () =>
    api.get<ProfileResponse>('/profile'),

  // Change password
  changePassword: (data: ChangePasswordRequest) =>
    api.put('/profile/password', data),

  // Register this browser's web-push token so the backend can push to it.
  registerPushToken: (token: string) =>
    api.post('/profile/push-token', { token, platform: 'web' }),

  // Remove this browser's web-push token (called on logout).
  unregisterPushToken: (token: string) =>
    api.delete('/profile/push-token', { data: { token } }),
};
